<script>
import { ECheckbox } from '../vuetify'
import { VIcon } from 'vuetify/lib'

export default {
  name: 'EChecklist',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: Boolean,
    inputValue: Boolean,
    disabled: Boolean,
    readonly: Boolean,
    label: String,
  },
  computed: {
    classes() {
      return {
        'e-checklist--disabled': this.disabled,
      }
    },
  },

  render(h) {
    const data = {
      staticClass: 'e-checklist',
      class: this.classes,
    }
    return h('div', data, [
      h(ECheckbox, {
        props: { ...this._props, inputValue: this.value },
        on: {
          change: (e) => {
            this.$emit('change', Boolean(e))
          },
          click: (e) => {
            this.$emit('click', e)
          },
          mouseup: (e) => {
            this.$emit('mouseup', e)
          },
          mousedown: (e) => {
            this.$emit('mousedown', e)
          },
        },
      }),
      this.readonly && h(VIcon, { staticClass: 'e-checklist__readonly' }, 'icon-lock_locked'),
    ])
  },
}
</script>
